import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "dashboards-card__body" }
const _hoisted_2 = { class: "dashboards-card__header" }
const _hoisted_3 = { class: "dashboards-card__title" }
const _hoisted_4 = { class: "dashboards-card__wrapper-indicators" }
const _hoisted_5 = { class: "indicator-card__value dashboards-card__value" }
const _hoisted_6 = { class: "dashboards-card__value-description" }
const _hoisted_7 = { class: "indicator-card__value dashboards-card__value" }
const _hoisted_8 = { class: "dashboards-card__bottom" }
const _hoisted_9 = {
  key: 0,
  class: "dashboards-card__bottom-info"
}
const _hoisted_10 = { class: "indicator-card__percent" }
const _hoisted_11 = {
  key: 2,
  class: "dashboards-card__arrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_IndicatorCard = _resolveComponent("IndicatorCard")!

  return (_openBlock(), _createBlock(_component_IndicatorCard, {
    class: _normalizeClass([
      'dashboards-card',
      `dashboards-card--${_ctx.variant}`,
      { 'dashboards-card_loading': _ctx.isLoading, 'dashboards-card_clickable': _ctx.isClickable },
    ]),
    onClick: _ctx.handleCardClick
  }, {
    values: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.card.title), 1),
          (_ctx.$slots.tooltip)
            ? (_openBlock(), _createBlock(_component_Tooltip, {
                key: 0,
                class: "tooltip-component--mobile-big"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "tooltip", {}, undefined, true)
                ]),
                _: 3
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["dashboards-card__content", { 'dashboards-card__content_dense': !_ctx.isShowAPPG }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(['dashboards-card__indicators', `dashboards-card__indicators--${_ctx.indicatorsColor}`])
            }, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.card?.amount ?? 0), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getCardText), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.card?.total ?? ''), 1)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.isShowAPPG)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", {
                      class: _normalizeClass([_ctx.getTextColor, 'margin-5', 'dashboards-card__amount-difference'])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(['fas fa-solid arrow', _ctx.getTextColor, _ctx.getArrowIcon])
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getAmountDifferenceValue), 1)
                    ], 2)
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("p", { class: "dashboards-card__trend" }, "к АППГ", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isLinkVariant)
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 1,
                  class: "dashboards-card__link",
                  to: _ctx.link,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("span", { class: "dashboards-card__arrow" }, null, -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]))
              : (!_ctx.isSimpleCardVariant)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : _createCommentVNode("", true)
          ])
        ], 2)
      ])
    ]),
    _: 3
  }, 8, ["class", "onClick"]))
}